import React, { useEffect } from 'react';
import { Timeline, Spin, Flex } from 'antd';
import { mdiDatabaseOff } from '@mdi/js';
import { Icon } from '@mdi/react';
import { useUserJourneyMutation } from 'modules/ReportModule/api/report.api';
import useQueryParams from 'hooks/useQueryParams';
import Ninja from '@ninja';
import { LoadingOutlined } from '@ant-design/icons';
import EventTimelineItem from './EventTimelineItem';
import SessionTimelineItem from './SessionTimelineItem';

const UserJourney = ({ trigger }) => {
  const { searchParams } = useQueryParams();
  const { user_id, event_id, session_id, ad_ids, adset_ids, campaign_ids, website_id } =
    searchParams;
  const [fetchUserJourneyQuery, { isFetching, isLoading, data, reset }] = useUserJourneyMutation();

  const parseIds = (value) => (value?.length ? value.split(',').map(Number) : []);

  const runQuery = (params) => {
    const query = {};
    if (params.user_id) query.user_id = params.user_id;
    if (params.event_id) query.event_id = params.event_id;
    if (params.session_id) query.session_id = params.session_id;
    if (params.ad_ids) query.ad_ids = parseIds(params.ad_ids);
    if (params.adset_ids) query.adset_ids = parseIds(params.adset_ids);
    if (params.campaign_ids) query.campaign_ids = parseIds(params.campaign_ids);
    if (params.website_id) query.website_id = params.website_id;
    fetchUserJourneyQuery(query).unwrap();
  };

  useEffect(() => {
    const data = { user_id, event_id, session_id, ad_ids, adset_ids, campaign_ids, website_id };
    if (!Object.values(data).find((v) => v > 0)) {
      reset();
    }
    runQuery(data);
  }, [user_id, event_id, session_id, ad_ids, adset_ids, campaign_ids, website_id]);

  const items = [];

  data?.sessions?.forEach((session) => {
    session.events?.forEach((event) => {
      items.push(EventTimelineItem({ event, url: session?.url, trigger: trigger, session }));
    });
    items.push(SessionTimelineItem({ session, trigger: trigger }));
  });

  if (isFetching || isLoading) {
    return (
      <Spin
        indicator={<LoadingOutlined spin />}
        size='large'
        className='flex justify-center mt-5'
      />
    );
  }

  if (items.length === 0) {
    return (
      <Flex
        gap='small'
        align='center'
        justify='center'
        vertical
        className='mt-5 text-sm font-normal color-light text-dark-text'
      >
        <Icon path={mdiDatabaseOff} color={Ninja.colors.gray} className='m-auto' />
        No data found
      </Flex>
    );
  }

  return (
    <div className='mx-2 mt-4 sm:ml-4 journey-timeline'>
      <Timeline items={items} mode='left' className='' />
    </div>
  );
};

UserJourney.propTypes = {};

export default UserJourney;
